import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnifyingGlassHandLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5007 95.0009C26.5007 94.5008 27.3007 94.2009 26.5007 93.0009C25.5007 91.5009 15.9424 79.9764 15.5007 76.0009C15.0007 71.5008 16.5007 66.0008 23.0007 65.0008M23.0007 65.0008C28.2007 64.2008 31.1674 66.8342 32.5007 68.0009M23.0007 65.0008C21.834 62.5008 24.9007 56.5008 30.5007 56.5008M30.5007 56.5008C36.1007 56.5008 39.1674 58.8342 40.0007 60.0008M30.5007 56.5008C30.5007 54.1675 32.5053 50.4448 36.5007 50.0008C41.0007 49.5008 45.5007 53.8342 47.5007 55.5008",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.9999 94.9993C59.4999 89.9993 56.2999 79.7993 55.4999 78.9993C54.6999 78.1993 53.4999 80.3327 52.9999 80.9994C55.1666 77.9994 58.5909 71.9753 58.9999 68.4993C59.9999 59.9993 57.9999 56.9993 54.9999 55.4993C48.9999 51.9994 39.7999 60.0993 36.9999 62.4993C32.4999 66.9994 28.3436 72.2103 33.4999 73.4994C35.4999 73.9994 36.9999 73.4994 38.4999 72.4994C39.9999 71.4994 46.7109 65.6572 49.9999 64.9994C52.4999 64.4994 53.6666 67.4994 53.9999 67.4994",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 74C23.3215 74.4969 24.4796 75.8167 25 76.5M36 75.5C36 75.5 40.5 83 38.5 84C36.5 85 33.5 84 32 83C29.5147 81.3432 27.4471 79.7129 25 76.5M25 76.5L25.5 73.5",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75 60C78.1667 59.1667 86.3232 59.3687 85 64C84 67.5 81.5 67 81.5 65C81.5 61.4645 83.5 56 87 57C90.5 58 92.5 61.125 91 61.5C89 62 86 57 90 55.5C93.2 54.3 94.6667 54 95 54",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35 29.5L27 30.5",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35 19C34.2 18.6 29 16.1667 26.5 15",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.5 8L32 2",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 68,
			cy: 27,
			r: 25.5,
			stroke: "#4F49BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68 1.5C82.0925 1.5 93.5 12.702 93.5 26.5C93.5 40.298 82.0925 51.5 68 51.5C53.9075 51.5 42.5 40.298 42.5 26.5C42.5 12.702 53.9075 1.5 68 1.5Z",
			stroke: "#4F49BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.026 85.6232L14.1251 91.169C13.9424 91.3759 13.9622 91.6922 14.169 91.875C14.376 92.0577 14.6923 92.038 14.8751 91.8311L19.9122 86.1312L19.026 85.6232ZM48.7131 53.5407L52.8751 48.8311L52.9337 48.7491C53.0498 48.5474 53.0123 48.2851 52.8311 48.125C52.6499 47.9651 52.3851 47.9604 52.1993 48.1006L52.1251 48.169L47.8269 53.0327L48.7131 53.5407Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 67,
			cy: 12,
			r: 6,
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49 15.5C50.8333 17 54.8 19.2 58 20C62 21 59.7414 27.6896 58.5 31C57 35 49.6667 29.3333 45.5 27",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.9995 45.5003C78.4995 45.5003 69.4995 41.5003 68.9995 42.0003C68.4995 42.5003 65.9995 48.0003 66.9995 48.5003C67.7995 48.9003 68.6661 49.0003 68.9995 49.0003",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0007 24.5005C88.5007 24.0005 81.0007 18.5005 79.0007 20.5005C77.0007 22.5005 76.5007 28.5005 77.0007 30.0005C77.4007 31.2005 84.834 33.5005 88.5007 34.5005",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 95,
			width: 96,
			height: 1,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 92.9998C27 92.9998 47.5 93.4998 48.5 90.9998C49.5 88.4998 58.5 88.9998 58.5 88.9998L60.5 94.9998L27 94.9998V92.9998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 83.5L25 79.5",
			stroke: "black"
		})
	]
});
export default SvgMagnifyingGlassHandLight;
